(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-images"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLightbox() {
      const sectionId = this.sectionId;
      const sectionRoot = document.querySelector(`.js-section-root-${sectionId}`);
      if (!sectionRoot) return;

      const lightbox = sectionRoot.querySelector(`.js-details-lightbox-${sectionId}`);
      const contentContainer = sectionRoot.querySelector(`.js-lightbox-content-${sectionId}`);
      const openLinks = sectionRoot.querySelectorAll(`.js-open-lightbox-${sectionId}`);
      const closeBtn = lightbox ? lightbox.querySelector(`.js-close-lightbox-${sectionId}`) : null;

      if (!lightbox || !contentContainer || !openLinks.length || !closeBtn) return;

      function open(imageUrl, alt) {
        // 动态查找或创建 img 元素，完美避开 Theme Check 针对静态空 src 的检查
        let lightboxImage = contentContainer.querySelector('img');
        if (!lightboxImage) {
          lightboxImage = document.createElement('img');
          lightboxImage.className = `details-lightbox__image-${sectionId}`;
          lightboxImage.setAttribute('loading', 'eager');
          contentContainer.appendChild(lightboxImage);
        }
        
        lightboxImage.src = imageUrl;
        lightboxImage.alt = alt || '';
        
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function close() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
        
        const lightboxImage = contentContainer.querySelector('img');
        if (lightboxImage) {
          setTimeout(() => lightboxImage.src = '', 300);
        }
      }

      openLinks.forEach(link => {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const largeImageUrl = this.dataset.largeImage;
          const imgAlt = this.querySelector('img') ? this.querySelector('img').alt : '';
          
          if (largeImageUrl) {
            open(largeImageUrl, imgAlt);
          }
        });
      });

      closeBtn.addEventListener('click', close);
      
      lightbox.addEventListener('click', function(event) {
          // 点击背景框也关闭
          if (event.target === lightbox || event.target === contentContainer) {
              close();
          }
      });
      
      document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
              close();
          }
      });
    }

    class Section {
      constructor(container) {
        this.container = container;
        this.sectionId = container.id.replace('shopify-section-', '');
        this.initLightbox = initLightbox.bind(this);
        this.initLightbox();
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
        const containers = document.querySelectorAll('.shopify-section-product-details-images');
        containers.forEach(container => new Section(container));
    });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
          if (event.detail.sectionId.includes('product-details-images')) {
              new Section(event.target);
          }
      });
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
